import { render, staticRenderFns } from "./BalanceKpisTab.vue?vue&type=template&id=df10bc10&scoped=true"
import script from "./BalanceKpisTab.vue?vue&type=script&lang=js"
export * from "./BalanceKpisTab.vue?vue&type=script&lang=js"
import style0 from "./BalanceKpisTab.vue?vue&type=style&index=0&id=df10bc10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df10bc10",
  null
  
)

export default component.exports